import type { ComponentType } from "react";
import type { ChatMessageViewModel } from "../../models/chatMessageViewModel";
import { isCommercialSimulatorSubBrandToolRequest, isCommercialSimulatorToolRequest } from "../../models/toolRequestModels";
import PlanToolCallSteps from "./planToolCallSteps";
import SubBrandToolCallSteps from "./subBrandToolCallSteps";

export type ToolComponentProps = {
    message: ChatMessageViewModel;
};

export type ToolDefinition<TToolRequest> = {
    isMatch: (payload: unknown) => payload is TToolRequest;
    Component: ComponentType<ToolComponentProps>;
};

type ToolResolverProps = {
    message: ChatMessageViewModel;
};
function defineTool<TToolRequest>(
    definition: ToolDefinition<TToolRequest>
): ToolDefinition<TToolRequest> {
    return definition;
};

const toolDefinitions = [
    defineTool({
        isMatch: isCommercialSimulatorToolRequest,
        Component: PlanToolCallSteps
    }),
    defineTool({
        isMatch: isCommercialSimulatorSubBrandToolRequest,
        Component: SubBrandToolCallSteps
    })
];

const renderTool = (message: ChatMessageViewModel) => {
    for (const definition of toolDefinitions) {
        if (definition.isMatch(message.payload)) {
            const Component = definition.Component;

            return (
                <>
                    {message.text && <p className="mb-2">{message.text}</p>}
                    <Component message={message} />
                </>
            );
        }
    }

    return undefined;
};

const ToolRenderer: React.FC<ToolResolverProps> = ({
    message
}) => {
    const tool = renderTool(message);
    if (tool) {
        return tool;
    }

    return (
        <p className="mb-0" style={{ whiteSpace: "pre-wrap" }}>
            {message.text}
        </p>
    );
};

export default ToolRenderer;
